import React from "react";
import PropTypes from "prop-types";
import Glass from "../Glass";
import {
  LoadingContainer,
  LdsFacebookContainer,
  LdsFacebookLoading,
  LdsFacebookLoadingBar,
  LoadingGlass,
} from "./Loading.Style";

const Loading = ({ loading, children }) => {
  return (
    <LoadingContainer>
      {children}
      <LoadingGlass as={Glass} show={loading}>
        <LdsFacebookContainer>
          <LdsFacebookLoading className="lds-facebook">
            <LdsFacebookLoadingBar className="lds-facebook-bar" />
            <LdsFacebookLoadingBar className="lds-facebook-bar" />
            <LdsFacebookLoadingBar className="lds-facebook-bar" />
          </LdsFacebookLoading>
        </LdsFacebookContainer>
      </LoadingGlass>
    </LoadingContainer>
  );
};

Loading.propTypes = {
  loading: PropTypes.bool,
};

Loading.defaultProps = {
  loading: false,
};

export default Loading;
